import React from 'react';
import { ServiceCard } from './ServiceCard';
import { ConsultationPanel } from './ConsultationPanel';
export const Services: React.FC = () => {
  const services = [{
    title: 'Full Service',
    description: ['Full Service is for couples who want comprehensive support from start to finish. We handle every detail, from sourcing and managing the vendor team to reviewing contracts, overseeing budgets, and creating a cohesive design vision.', 'From early planning, we guide the process every step of the way so you can enjoy the journey. On the big day, our team ensures everything runs seamlessly, allowing you to be fully present in the celebration.']
  }, {
    title: 'Partial Planning',
    description: ['Partial Planning is for couples who have booked their venue and a few vendors but want support to bring the rest together. We help secure remaining vendors, refine design details, and manage budgets so your plans come together smoothly.', 'In the final months, we provide planning touchpoints and a site visit to confirm everything is aligned. On wedding day, you can relax knowing our team is managing the flow and bringing your vision to life.']
  }, {
    title: 'Event Management',
    description: ['Event Management is for couples who have planned their wedding and are ready to hand it off to a professional to bring it all together. Two months before the big day, we learn your vision, connect with all vendors, and create a smooth timeline.', 'On the wedding day, we bring your vision to life from start to finish, managing logistics, vendors, and flow. With everything in our hands, you can relax and be fully present in the celebration.']
  }];
  return <section id="services" className="min-h-[80vh] bg-cover bg-center relative py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8" style={{
    backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/bfPK9PrgDXW2Mfgii9E9sr/veil_background.jpg)'
  }} data-id="element-161">
      {/* Lighter overlay so background is more visible */}
      <div className="absolute inset-0 bg-white/60" data-id="element-162" />

      <div className="relative z-10 max-w-7xl mx-auto" data-id="element-163">
        <header className="mb-12 sm:mb-16 text-center" data-id="element-164">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-[#486878] mb-4 sm:mb-6" data-id="element-165">
            Services
          </h2>
          <p className="text-[#486878] text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-166">
            Our services are tailored to your unique needs and vision.
          </p>
        </header>

        {/* Changed to single column on medium screens, 3 columns on large */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-10 max-w-6xl mx-auto" data-id="element-167">
          {services.map((service, index) => <ServiceCard key={index} {...service} data-id="element-168" />)}
        </div>

        <ConsultationPanel data-id="element-169" />
      </div>
    </section>;
};